module.exports = __webpack_public_path__ + "static/img/shui2.175d25f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/shui2.png
// module id = CSzb
// module chunks = 44